module.exports = __webpack_public_path__ + "static/media/cash_icon.11856d44.svg";